import { render, staticRenderFns } from "./HotBroadcaster.vue?vue&type=template&id=3cb96845&scoped=true"
import script from "./HotBroadcaster.vue?vue&type=script&lang=js"
export * from "./HotBroadcaster.vue?vue&type=script&lang=js"
import style0 from "./HotBroadcaster.vue?vue&type=style&index=0&id=3cb96845&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb96845",
  null
  
)

export default component.exports